import { ChatPage } from '@/pages/ChatPage';
import { CostDebugPage } from '@/pages/debug/CostDebugPage';
import { EventsDebugPage } from '@/pages/debug/EventsDebugPage';
import { MainPage } from '@/pages/MainPage';
import { privateEnvLoader } from '@/loaders/PrivateEnvLoader';
import { PubSubDebugPage } from '@/pages/debug/PubSubDebugPage';
import { RestrictedPage } from '@/pages/RestrictedPage';
import { SharePage } from '@/pages/SharePage';

import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouteObject,
} from 'react-router-dom';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Outlet />,
    loader: privateEnvLoader,
    children: [
      { index: true, element: <Navigate to="/chat" replace /> }, // Redirect "/" to "/chat"
      {
        path: '/chat',
        element: <MainPage />,
        children: [
          { index: true, element: <ChatPage /> },
          { path: ':threadId', element: <ChatPage /> },
        ],
      },
      {
        path: '/share/:threadId',
        element: <SharePage />,
      },
      {
        path: '/debug/pubsub',
        element: <PubSubDebugPage />,
      },
      {
        path: '/debug/cost',
        element: <CostDebugPage />,
      },
      {
        path: '/debug/cost/:threadId',
        element: <CostDebugPage />,
      },
      {
        path: '/debug/events',
        element: <EventsDebugPage />,
      },
      {
        path: '/debug/events/:threadId',
        element: <EventsDebugPage />,
      },
    ],
  },

  {
    path: '/restricted',
    element: <RestrictedPage />,
  },
];

export const router = createBrowserRouter(routes);
